import { default as region } from './region/routes'
import { default as departament } from './departament/routes'
import { default as establishment } from './establishment/routes'
import { default as partnerCompany } from './partner_company/routes'

export default [
    ...region,
    ...departament,
    ...establishment,
    ...partnerCompany,
    {
        path: '/institutions',
        name: 'InstitutionIndex',
        component: () => import ('./pages/Index'),
    }
]